import { Dispatch, FC, SetStateAction } from 'react';
import useAddJourneyModal from './AddJourneyModal.hook';
import DialogForm from 'components/DialogForm';
import Box from 'yoda-ui/components/Box';
import SelectYoda from 'yoda-ui/components/Form/SelectYoda';
import MultiSelectYoda from 'yoda-ui/components/Form/SelectYoda/MultiSelectYoda';
import TextYoda from 'yoda-ui/components/Form/TextYoda/TextYoda';
import { YodaFormProvider } from 'yoda-ui/yodaForm';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

type AddJourneyModalProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onJourneySave?: () => void;
};

const AddJourneyModal: FC<AddJourneyModalProps> = ({ open, setOpen, onJourneySave }) => {
  const {
    addJourneyConfig,
    cancelButtonConfig,
    providerFields,
    submitButtonConfig,
    t,
  } = useAddJourneyModal(setOpen, onJourneySave);

  return (
    <YodaFormProvider { ...providerFields }>
      <DialogForm
        dialogTitle={ t('manage_journeys_add_journey_title') }
        open={ open }
        setOpen={ setOpen }
        cancelButtonConfig={ cancelButtonConfig }
        submitButtonConfig={ submitButtonConfig }
      >
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={ YodaSpacing.medium }>
          <TextYoda { ...addJourneyConfig.name } />
          <SelectYoda { ...addJourneyConfig.channel } />
          <TextYoda { ...addJourneyConfig.sfmcJourneyApiKey } />
          <SelectYoda { ...addJourneyConfig.format } />
          <TextYoda { ...addJourneyConfig.timeInHour } />
          <MultiSelectYoda { ...addJourneyConfig.marketDefaults } />
          <TextYoda { ...addJourneyConfig.reminderType } />
        </Box>
      </DialogForm>
    </YodaFormProvider>
  );
};

export default AddJourneyModal;
